import { api } from './api';

const orderGetPageList = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `Orders/getOrderList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const orderDetailsGetPageList = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `OrderDetails/getOrderDetailList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const packagesGetPagedList = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `Packages/getPagedList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const packagesUpdate = async (data) => {
    const response = await api({
        url: `Packages/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const orderInfosGetList = async ({data, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `OrderInfos/getOrderInfoList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...data,
        },
    });
    return response.data;
};

const orderDelete = async (data) => {
    const response = await api({
        url: `Orders/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            ...data,
            customerId: window.customerId
        },
    });
    return response.data;
};

const paymentLinksAdd = async (data) => {
    const response = await api({
        url: `PaymentLinks/add`,
        method: 'POST',
        data,
    });
    return response.data;
};

const getMailList = async (id) => {
    const response = await api({
        url: `Users/getUserMailList`,
        method: 'GET',
        params: {
            customerId: id,
        },
    });
    return response.data;
};

const downloadOrderFile = async (data) => {
    const response = await api({
        url: `Orders/downloadOrderFile`,
        method: 'GET',
        params: data,
        responseType: 'blob',
    });
    return response.data;
};

const orderServices = {
  orderGetPageList,
  orderDetailsGetPageList,
  packagesGetPagedList,
  packagesUpdate,
  orderInfosGetList,
  orderDelete,
  paymentLinksAdd,
  getMailList,
  downloadOrderFile,
};

export default orderServices;
